import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList } from 'react-window';
import ReactWindowRow from 'flow/components/react-window-row';

const VariableSizeWindowingList = ({ items, getItemSize, overscanCount }) => {
    const listRef = useRef();

    if (listRef.current) {
        // We reset the whole list item height cache here. We could calculate from
        // which index to clear the cache here but that would add extra complexity
        // and will be hard to maintain so we go with this approach and will
        // optimize it if we see that it's necessary.
        // Getting the item height from this.getListItemHeight is a very fast
        // operation.
        listRef.current.resetAfterIndex(0, false);
    }

    return (
        <div className="h-full flex-auto">
            <AutoSizer>
                {({ height, width }) => (
                    <VariableSizeList
                        height={height}
                        itemCount={items.length}
                        itemSize={getItemSize}
                        width={width}
                        itemData={items}
                        overscanCount={overscanCount}
                        ref={listRef}
                        style={{ overflowY: 'overlay', direction: undefined }} //direction: undefined seems to be needed for list to be flipped when direction is Right-to-Left
                        className="scrollbar"
                    >
                        {ReactWindowRow}
                    </VariableSizeList>
                )}
            </AutoSizer>
        </div>
    );
};

VariableSizeWindowingList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.node),
    getItemSize: PropTypes.func,
    overscanCount: PropTypes.number,
};

VariableSizeWindowingList.defaultProps = {
    items: [],
    getItemSize: () => 0,
    overscanCount: 7,
};

export default React.memo(VariableSizeWindowingList);
